/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { DRAG_DROP_PASTE } from "@lexical/rich-text"
import { isMimeType, mediaFileReader } from "@lexical/utils"
import { COMMAND_PRIORITY_LOW } from "lexical"
import { useEffect } from "react"
import { INSERT_INLINE_IMAGE_COMMAND } from "../InlineImagePlugin"
import { useTextEditorContext } from "../../TextEditor.context"

export default function DragDropPaste(): null {
  const [editor] = useLexicalComposerContext()
  const { disabledAssetTypes } = useTextEditorContext()

  useEffect(
    function setupImageDrop() {
      return editor.registerCommand(
        DRAG_DROP_PASTE,
        (files) => {
          void (async () => {
            const filesResult = await mediaFileReader(files, ["image/"])
            for (const { file } of filesResult) {
              if (disabledAssetTypes?.includes(file.type)) return false

              if (isMimeType(file, ["image/"])) {
                editor.dispatchCommand(INSERT_INLINE_IMAGE_COMMAND, {
                  src: URL.createObjectURL(file),
                  fileName: file.name,
                  fileType: file.type,
                })
              }
            }
          })()
          return true
        },
        COMMAND_PRIORITY_LOW
      )
    },
    [disabledAssetTypes, editor]
  )
  return null
}
